import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIDefinitionsPluginState } from './types';

export const aiDefinitionsPluginKey: PluginKey<AIDefinitionsPluginState> =
	new PluginKey<AIDefinitionsPluginState>('aiDefinitions');
